module.exports = __webpack_public_path__ + "img/banner.d89a88c7.jpg";